import { ReactNode, useState, createContext, useContext } from 'react';
import { Box, Flex } from '@mantine/core';

interface HoverDisplayContextValue {
  isHovered: boolean;
  setIsHovered: (value: boolean) => void;
}

const HoverDisplayContext = createContext<HoverDisplayContextValue | null>(null);

interface HoverDisplayProps {
  children: ReactNode;
}

function HoverDisplayRoot({ children }: HoverDisplayProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <HoverDisplayContext.Provider value={{ isHovered, setIsHovered }}>
      <Flex onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} justify="inherit">
        {children}
      </Flex>
    </HoverDisplayContext.Provider>
  );
}

interface HoverDisplayTargetProps {
  children: ReactNode;
}

function HoverDisplayTarget({ children }: HoverDisplayTargetProps) {
  const context = useContext(HoverDisplayContext);

  if (!context) {
    throw new Error('HoverDisplay.Target must be used inside HoverDisplay');
  }

  const { isHovered } = context;

  return (
    <Box
      style={{
        opacity: isHovered ? 1 : 0,
        transition: 'opacity 0.2s ease, visibility 0.6s ease',
      }}
    >
      {children}
    </Box>
  );
}

export const HoverDisplay = Object.assign(HoverDisplayRoot, {
  Target: HoverDisplayTarget,
});
